import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { LIST_SEARCH_LIMIT } from 'config';
import { useSelector } from 'react-redux';
import { useDataLayer } from 'hooks/useDataLayer';
import { getPropertyLinkQueryString } from 'store/search/searchSelectors';
import { getQueryPage } from 'store/search/searchSelectors/querySelectors';
import AppLink from 'components/AppLink';
import { usePersonalisation } from 'hooks/usePersonalisation';

const SearchResultLink = ({ children, propertyId, cardIndex, ariaLabel }) => {
  const propertyQueryString = useSelector(getPropertyLinkQueryString);
  const paginationIndex = useSelector(getQueryPage);
  const { emitInteractionEvent } = useDataLayer();
  const personalisation = usePersonalisation();

  const propertyUrl = `/properties/${propertyId}?${propertyQueryString}`;

  const handlePropertyLinkOnClick = useCallback(() => {
    const cardsOnPrevPages = paginationIndex ? (paginationIndex - 1) * LIST_SEARCH_LIMIT : 0;
    const cardNumber = cardIndex + 1;
    const customAttributes = { user_event_value: propertyId };
    emitInteractionEvent({ type: 'Property Card', value: `Card ${cardsOnPrevPages + cardNumber} selected`, customAttributes });
    personalisation.trackSearchClick(propertyId);
  }, [personalisation, emitInteractionEvent, cardIndex, paginationIndex, propertyId]);

  return (
    <AppLink
      to={propertyUrl}
      onClick={handlePropertyLinkOnClick}
      aria-label={ariaLabel}
      data-gtmqueryselector="resultItem"
      data-expanded-clickable-area-target
    >
      {children}
    </AppLink>
  );
};

SearchResultLink.propTypes = {
  children: PropTypes.node.isRequired,
  propertyId: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  cardIndex: PropTypes.number.isRequired,
};

export default SearchResultLink;
